/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-01-21 18:30:40
 */

import Api from 'src/util/api';
import { PageDo, Result, ResultPageDo, Integer } from 'src/types/base';
export declare namespace DayReportDOI {
    export interface RowDataI {}

    export interface QueryRowDataParamsI extends PageDo {
        mn?: string;
        start_time: Integer;
        end_time: Integer;
    }

    export interface DatePickerOptions {
        /**
         * 设置快捷选项，每项内容：
         * text：显示的文案
         * value?: 返回指定的日期，如需自己控制逻辑，可不设置，并使用 onClick 回调
         * onClick?: 点击时的回调，参数为当前日期选择器的 Vue 实例，当需要自定义复杂操作时，可以使用
         */
        shortcuts?: { text?: string, value?: () => void, onClick?: () => void }[];
        /**
         * 设置不可选择的日期，参数为当前的日期，需要返回 Boolean 是否禁用这天
         */
        disabledDate(date): boolean;
    }
}
export default class DayReportApi {
    /**
     * 查询列表
     * @param {DayReportDOI.QueryRowDataParamsI} params
     * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
     */
    // static async searchDayList(
    //     params: DayReportDOI.QueryRowDataParamsI,
    // ): Promise<ResultPageDo<any[], { key: string; name: string; unit: string }[]>> {
    //     return Api.post('/monitor/point/forms/data/get', {
    //         ...params,
    //         cn: '2011',
    //     });
    // }

    static async searchDayList(
        params: DayReportDOI.QueryRowDataParamsI,
    ): Promise<ResultPageDo<any[], { key: string; name: string; unit: string }[]>> {
        return Api.post('/monitor/hwk_point/forms/data/get', {
            ...params,
            cn: '2061',
        });
    }

    // static async searchWeekMonthList(
    //     params: DayReportDOI.QueryRowDataParamsI,
    // ): Promise<ResultPageDo<any[], { key: string; name: string; unit: string }[]>> {
    //     return Api.post('/monitor/point/forms/data/other/get', {
    //         ...params,
    //         cn: '2011',
    //     });
    // }

    static async searchWeekMonthList(
        params: DayReportDOI.QueryRowDataParamsI,
    ): Promise<ResultPageDo<any[], { key: string; name: string; unit: string }[]>> {
        return Api.post('/monitor/hwk_point/forms/data/other/get', {
            ...params,
            cn: '2061',
        });
    }
    // static async searchYearList(
    //     params: DayReportDOI.QueryRowDataParamsI,
    // ): Promise<ResultPageDo<any[], { key: string; name: string; unit: string }[]>> {
    //     return Api.post('/monitor/point/forms/data/year/get', {
    //         ...params,
    //         cn: '2011',
    //     });
    // }

    static async searchYearList(
        params: DayReportDOI.QueryRowDataParamsI,
    ): Promise<ResultPageDo<any[], { key: string; name: string; unit: string }[]>> {
        return Api.post('/monitor/hwk_point/forms/data/year/get', {
            ...params,
            cn: '2061',
        });
    }

    static async export(type: string): Promise<Result<{download_url: string}>> {
        let url = ''
        switch (type) {
            case '日报':
                url = '/monitor/single_site/daily/export'
                break;
            case '周报':
                url = '/monitor/single_site/weekly/export'
                break;
            case '月报':
                url = '/monitor/single_site/monthly/export'
                break;
            case '年报':
                url = '/monitor/single_site/yearly/export'
                break;
        }
        return Api.post(url);
    }

    static async exportChange(params: any): Promise<Result<{download_url: string}>> {
        return Api.post('/monitor/hwk_point/forms/data/report/get', {
            ...params,
        });
    }
}
